import { PipImprovementActivityApiModel, sanitizeIfPresent, toDateOrNull } from './pip-improvement-activity.model';

export class PipFormInstanceDetailsApiModel {
  public PlanId: number;
  public FormAction: number;

  // Frozen form settings (copied from the PE form when the instance was created)
  public PipImprovementPlanEnabled: boolean;
  public PipImprovementPlanReasonForImprovementPlan: boolean;
  public PipImprovementPlanReasonNarrative: boolean;
  public PipImprovementPlanPossibleConsequences: boolean;
  public PipImprovementPlanConsequencesNarrative: boolean;
  public PipImprovementActivitiesEnabled: boolean;
  public PipImprovementActivitiesAllowComments: boolean;
  public PipImprovementActivitiesRequireComments: boolean;
  public PipImprovementFormsEnabled: boolean;
  public PipScheduleEnabled: boolean;

  // Improvement Plan tab
  public ImprovementPlanStartDate: Date;
  public ImprovementPlanProjectedEndDate: Date | null;
  public ReasonNarrative: string | null;
  public ConsequencesNarrative: string | null;
  public ReasonIds: number[];
  public ConsequenceIds: number[];

  // Improvement Activities tab
  public ImprovementActivities: PipImprovementActivityApiModel[];

  // Schedule tab
  public NextCheckPointDate: Date | null;
  public NextCheckPointComments: string | null;
  public NoScheduledCheckIn: boolean;

  // Summary tab
  public IsSummaryNotesRequire: boolean;
  public ShowPerformanceCategoryScores: boolean;

  public deserialize(data: object): this {
    Object.assign(this, data);

    this.ImprovementPlanStartDate = toDateOrNull(this.ImprovementPlanStartDate);
    this.ImprovementPlanProjectedEndDate = toDateOrNull(this.ImprovementPlanProjectedEndDate);
    this.NextCheckPointDate = toDateOrNull(this.NextCheckPointDate);

    this.ReasonIds = this.ReasonIds ?? [];
    this.ConsequenceIds = this.ConsequenceIds ?? [];
    this.ImprovementActivities = (this.ImprovementActivities ?? []).map((x) =>
      new PipImprovementActivityApiModel().deserialize(x)
    );

    sanitizePipRichText(this);

    return this;
  }
}

/** Sanitizes the rich-text fields in place. Works on plain objects too, so it is safe to call before sending an update. */
export function sanitizePipRichText(pip: PipFormInstanceDetailsApiModel | null | undefined): void {
  if (!pip) {
    return;
  }

  pip.ReasonNarrative = sanitizeIfPresent(pip.ReasonNarrative);
  pip.ConsequencesNarrative = sanitizeIfPresent(pip.ConsequencesNarrative);
  pip.NextCheckPointComments = sanitizeIfPresent(pip.NextCheckPointComments);
  (pip.ImprovementActivities ?? []).forEach((x) => (x.Comment = sanitizeIfPresent(x.Comment)));
}
